import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Container,
    TwoColumnsLayout,
    ImageColumn,
    ContentColumn,
    ModuleImage,
    Text,
    ContentFooter,
    ButtonContainer,
} from './MentalTestOptOutIntro.style';
import cognitiveAbilitiesImage from 'assets/images/cognitive_abilities_module.png';
import ShadowButton from 'components/shared/ShadowButton/ShadowButton';
import withMediaQuery from '../../../hoc/MediaQuery/withMediaQuery';
import { Spacer } from '../../shared/CameraSetupView/MobileView/MobileCameraSetup/MobileCameraSetup.style';

const MentalTestOptOutIntro = (props) => {
    const { t } = useTranslation();
    const { onNext, isTabletAndMobileSize } = props;

    return (
        <Container>
            {isTabletAndMobileSize && (
                <>
                    <TwoColumnsLayout>
                        <Text>
                            <h1>
                                {t(
                                    'COGNITIVE_ABILITIES_MODULE.OPT_OUT_INTRO.TITLE',
                                )}
                            </h1>
                        </Text>
                        <ImageColumn>
                            <ModuleImage src={cognitiveAbilitiesImage} />
                        </ImageColumn>
                    </TwoColumnsLayout>
                    <ContentColumn>
                        <div>
                            <Text>
                                <p>
                                    {t(
                                        'COGNITIVE_ABILITIES_MODULE.OPT_OUT_INTRO.MESSAGE_1',
                                    )}
                                </p>
                            </Text>
                            <Text>
                                <p>
                                    {t(
                                        'COGNITIVE_ABILITIES_MODULE.OPT_OUT_INTRO.MESSAGE_2',
                                    )}
                                </p>
                            </Text>
                            <Text>
                                <p>
                                    {t(
                                        'COGNITIVE_ABILITIES_MODULE.OPT_OUT_INTRO.MESSAGE_3',
                                    )}
                                </p>
                            </Text>
                            <Text>
                                <p>
                                    {t(
                                        'COGNITIVE_ABILITIES_MODULE.OPT_OUT_INTRO.MESSAGE_4',
                                    )}
                                </p>
                            </Text>
                        </div>
                        <Spacer />
                        <ContentFooter>
                            <ButtonContainer>
                                <ShadowButton
                                    size={'small'}
                                    onClick={() => onNext()}>
                                    {t(
                                        'COGNITIVE_ABILITIES_MODULE.OPT_OUT_INTRO.START_TASK_BUTTON',
                                    )}
                                </ShadowButton>
                            </ButtonContainer>
                        </ContentFooter>
                    </ContentColumn>
                </>
            )}
            {!isTabletAndMobileSize && (
                <TwoColumnsLayout>
                    <ImageColumn>
                        <ModuleImage src={cognitiveAbilitiesImage} />
                    </ImageColumn>
                    <ContentColumn>
                        <Text>
                            <h1>
                                {t(
                                    'COGNITIVE_ABILITIES_MODULE.OPT_OUT_INTRO.TITLE',
                                )}
                            </h1>
                            <p>
                                {t(
                                    'COGNITIVE_ABILITIES_MODULE.OPT_OUT_INTRO.MESSAGE_1',
                                )}
                            </p>
                            <p>
                                {t(
                                    'COGNITIVE_ABILITIES_MODULE.OPT_OUT_INTRO.MESSAGE_2',
                                )}
                            </p>
                            <p>
                                {t(
                                    'COGNITIVE_ABILITIES_MODULE.OPT_OUT_INTRO.MESSAGE_3',
                                )}
                            </p>
                            <p>
                                {t(
                                    'COGNITIVE_ABILITIES_MODULE.OPT_OUT_INTRO.MESSAGE_4',
                                )}
                            </p>
                        </Text>
                        <ContentFooter>
                            <ButtonContainer>
                                <ShadowButton onClick={() => onNext()}>
                                    {t(
                                        'COGNITIVE_ABILITIES_MODULE.OPT_OUT_INTRO.START_TASK_BUTTON',
                                    )}
                                </ShadowButton>
                            </ButtonContainer>
                        </ContentFooter>
                    </ContentColumn>
                </TwoColumnsLayout>
            )}
        </Container>
    );
};

export default withMediaQuery(MentalTestOptOutIntro);
